import { ThemeOptions } from '@mui/material';
import { tokens } from '../../../../theme/generated/tokens';

export const chartContainerTheme: ThemeOptions['components'] = {
  DsChartContainer: {
    styleOverrides: {
      root: {
        width: '100%',
        height: '100%',
        backgroundColor: tokens.theme.bg.structural.surface,
        borderRadius: tokens.theme.radius.sm,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      },
      title: ({ theme }) => ({
        ...theme.typography.L10M,
        paddingBottom: 12,
        color: tokens.theme.fg.structural.primary,
      }),
      container: ({ theme }) => ({
        '& .recharts-wrapper, & .recharts-wrapper:focus': {
          outline: 'none',
        },
        '& .recharts-surface': {
          outline: 'none',
          overflow: 'visible', // Required for Y axis scale with padded background to be visible in full
        },
        // Recharts a11y layer / SVG groups take focus on click; suppress the
        // browser focus ring so scatter clicks do not outline the whole series.
        '& svg:focus, & svg:focus-visible, & g:focus, & g:focus-visible, & path:focus, & path:focus-visible':
          {
            outline: 'none',
          },
        '& .x-axis-tick': {
          userSelect: 'none',
        },
        '& .recharts-tooltip-wrapper': {
          zIndex: theme.zIndex.tooltip, // above ChartActions (1000)
        },
      }),
    },
  },
};
